import { createFileRoute } from "@tanstack/react-router"

import Markdown from "@/components/markdown"
import content from "@/privacy/content.md?raw"

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
  head: () => ({
    meta: [{ title: "Privacy Policy | WattBot" }],
  }),
})

function PrivacyPage() {
  return (
    <div className="mx-auto max-w-(--breakpoint-sm)">
      <Markdown>{content}</Markdown>
      <section aria-labelledby="terminal-correction-heading" className="py-8">
        <h2 id="terminal-correction-heading" className="text-xl font-semibold">
          Terminal correction requests
        </h2>
        <p className="mt-3">
          If a Terminal File names you or describes your business role
          inaccurately, email{" "}
          <a
            className="underline"
            href="mailto:team@wattbot.app?subject=Terminal%20correction"
          >
            team@wattbot.app
          </a>
          . Include the business name, the File or finding, and what you believe
          is wrong. Please do not send a Social Security number, date of birth,
          or home address. We aim to make a decision within 30 days.
        </p>
      </section>
    </div>
  )
}
